import { FC } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const FiveCompleted: FC<Props> = ({ width = '54', height = '54' }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 54 54"
        fill="none"
        style={{ filter: 'drop-shadow(0 0 6px rgba(255, 97, 97, 0.50))' }}
      >
        <path
          d="M45 27C45 17.0589 36.9411 9 27 9C17.0589 9 9 17.0589 9 27C9 36.9411 17.0589 45 27 45C36.9411 45 45 36.9411 45 27ZM54 27C54 41.9117 41.9117 54 27 54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0C41.9117 0 54 12.0883 54 27Z"
          fill="#F06767"
        />
        <path
          d="M27 0C34.8481 0 41.9134 3.34913 46.8467 8.69531L40.583 15.1904C37.283 11.3981 32.4219 9 27 9C17.0589 9 9 17.0589 9 27C9 32.6574 11.6108 37.7041 15.6924 41.0039L9.42871 47.499C3.65718 42.5472 0 35.2011 0 27C0 12.0883 12.0883 0 27 0Z"
          fill="#F29090"
        />
        <path
          d="M53 27C53 12.6406 41.3594 1 27 1C12.6406 1 1 12.6406 1 27C1 41.3594 12.6406 53 27 53V54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0C41.9117 0 54 12.0883 54 27C54 41.9117 41.9117 54 27 54V53C41.3594 53 53 41.3594 53 27ZM45 27C45 17.0589 36.9411 9 27 9C17.0589 9 9 17.0589 9 27C9 36.9411 17.0589 45 27 45C36.9411 45 45 36.9411 45 27ZM46 27C46 37.4934 37.4934 46 27 46C16.5066 46 8 37.4934 8 27C8 16.5066 16.5066 8 27 8C37.4934 8 46 16.5066 46 27Z"
          fill="#F7F3F0"
        />
      </svg>
    </>
  );
};

export default FiveCompleted;
